<template>
  <div :class="['container', _isMobile() ? 'mobile' : '']">
    <Header />
    <!-- <div class="banner-wrap">
      <img class="banner-bg" style="" src="../assets/banner-bg1.png" alt="">
    </div> -->
    <div class="home">
      <router-view />
    </div>
    <a-back-top />
    <Footer />
  </div>
</template>

<script>
import Vue from "vue";
import { TENANT_CONFIG } from "@/store/mutation-types";
import { mixinDevice } from "@/utils/mixin.js";
import Header from "../components/Header";

import Footer from "../components/Footer";
export default {
  name: "CmdLayout",
  mixins: [mixinDevice],
  components: {
    Header,
    Footer,
  },
  data() {
    return {
      bgUrl: "/assets/background.svg",
    };
  },
  created() {
    const tenantConfig = Vue.ls.get(TENANT_CONFIG);
    if (tenantConfig && tenantConfig.homeBackground) {
      this.bgUrl = tenantConfig.themeConfig.homeBackground;
    }
  },
};
</script>
<style>
  a *{
    transition: all 0.1s ease;
  }
</style>
<style lang="less" scoped>
.container {
  background: #f2f6f8;
  .header{
    // background: linear-gradient(to top, #52a7e300, #5261c7d9);
  }
  .banner-wrap {
    .banner-bg{
      z-index: -1;
      position: absolute;
      width: 100%;
    }
    .banner {
      margin: auto;
      max-width: 1200px;
      overflow: hidden;
      border-radius: 0 0 10px 10px;
    }
  }
  .home {
    max-width: 1200px;
    margin: 80px auto 20px;
    padding: 20px;
    background: #ffffff4a;
    border-radius: 30px;
  }
  /deep/.ant-list-pagination {
    text-align: center;
  }
  // background: url(../assets/bg.png);
  // background-position: top;
  background: url(../assets/bg2.png);
}
</style>